"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _q = _interopRequireDefault(require("q"));

var _ActionTypes = _interopRequireDefault(require("crm_data/actions/ActionTypes"));

var SettingsAPI = _interopRequireWildcard(require("crm_data/settings/SettingsAPI"));

var _SettingsStore = _interopRequireDefault(require("crm_data/settings/SettingsStore"));

var _transact = require("crm_data/flux/transact");

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var Alerts = _interopRequireWildcard(require("customer-data-ui-utilities/alerts/Alerts"));

function notifyError() {
  Alerts.addError('settingsGeneric.error');
}

function notifySuccess() {
  Alerts.addSuccess('settingsGeneric.success');
}

var baseSet = function baseSet(key, value) {
  var oldValue = _SettingsStore.default.get() && _SettingsStore.default.get(key);

  return (0, _transact.transact)({
    operation: function operation() {
      return SettingsAPI.set(_hubspot.default.get(), key, value);
    },
    commit: [_ActionTypes.default.SET_SETTING, {
      key: key,
      value: value
    }],
    rollback: [_ActionTypes.default.REVERT_SETTING, {
      key: key,
      value: oldValue
    }]
  });
};

var baseDelete = function baseDelete(key) {
  var oldValue = _SettingsStore.default.get() && _SettingsStore.default.get(key);

  return (0, _transact.transact)({
    operation: function operation() {
      return SettingsAPI.del(_hubspot.default.get(), key);
    },
    commit: [_ActionTypes.default.DELETE_SETTING, {
      key: key
    }],
    rollback: [_ActionTypes.default.REVERT_SETTING, {
      key: key,
      value: oldValue
    }]
  });
};

var _default = {
  //Exposed to do something custom in auto associate. You probably shouldnt use this.
  _baseSet: baseSet,
  set: function set(key, value, silent) {
    if (Array.isArray(key)) {
      return _q.default.Promise.all(key.map(function (subKey) {
        return baseSet(subKey, value);
      })).then(function () {
        if (!silent) {
          notifySuccess();
        }
      }, notifyError);
    } else {
      return baseSet(key, value).then(function () {
        if (!silent) {
          notifySuccess();
        }
      }, notifyError);
    }
  },
  delete: function _delete(key, silent) {
    return baseDelete(key).then(function () {
      if (!silent) {
        notifySuccess();
      }
    }, notifyError);
  }
};
exports.default = _default;
module.exports = exports.default;